import React from "react";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const GetAppModal = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter rounded-4"
      top
      className="rounded-4"
      backdrop="static"
    >
      <Modal.Body className="bg-default rounded-4 modal-bg">
        <div className="d-flex justify-content-end">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            className="bi bi-x-lg"
            viewBox="0 0 16 16"
            onClick={props.onHide}
            aria-label="Close"
            style={{ cursor: "pointer" }}
          >
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
          </svg>
        </div>
        <Container className="py-5 px-5 rounded-4">
          <Row className="align-items-center justify-content-center">
            <Col lg={12}>
              <div className="d-flex justify-content-center mb-3">
                <h1 className="bebas-neue-font">
                  GET MOVING WITH
                  <span className="text-white"> Move!</span>
                </h1>
              </div>
            </Col>
            <Col lg={12}>
              <div className="d-flex justify-content-center mb-3">
                <p className="plus-jakarta-sans-font text-center fs-5">
                  Download the Move app, your one-stop fitness companion for
                  cycling, running, and walking events. Get all the information
                  and event details you need at your fingertips.
                </p>
              </div>
            </Col>
            <Col lg={12}>
              <div className="d-flex flex-row flex-wrap gap-5 justify-content-center align-items-center">
                <Link
                  to="https://play.google.com/store/apps?hl=en&gl=US"
                  target="_blank"
                >
                  <img
                    src="\media\assets\events\google-play.png"
                    alt=""
                    className="img-fluid"
                  />
                </Link>
                <Link to="https://www.apple.com/in/app-store/" target="_blank">
                  <img
                    src="\media\assets\events\app-store.png"
                    alt=""
                    className="img-fluid"
                  />
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default GetAppModal;
